import type { Asset } from '#modules/AssetOverview/AssetOverview.types'
import type { ExpenseEstimateDto } from '#modules/Budget/types/expense.types'
import type { FC } from 'react'

import { H2 } from '@monthio/design-system'
import { RemoveChain } from '@monthio/icons'
import { AssetCard } from '#modules/AssetOverview/Components/AssetCard'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ItemWithOptionalLogo } from '../../../../modulesTemp/shared/ItemWithOptionalLogo'
import { ExpenseEstimate } from '../expenseEstimate'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`
const AssetsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`
interface MissingExpenseEstimateAssetLinkPageProps {
	expenseEstimate: ExpenseEstimateDto
	assets: Asset[]
	onChange: (expenseEstimate: ExpenseEstimateDto) => void
}

export const MissingExpenseEstimateAssetLink: FC<
	MissingExpenseEstimateAssetLinkPageProps
> = ({ expenseEstimate, assets, onChange }) => {
	const { t } = useTranslation()

	const assignAsset = (assetId: string | null, isSelected: boolean) => {
		expenseEstimate.assetId = isSelected ? assetId : undefined
		onChange(expenseEstimate)
	}

	const possibleAssets = assets.filter((asset) =>
		expenseEstimate.possibleAssetIds.includes(asset.id.toString()),
	)

	return (
		<Wrapper>
			<ExpenseEstimate expenseEstimate={expenseEstimate} />
			<div>
				<H2>
					{t(
						'assetExpenses-missingExpenseEstimateAssetLinkPage-assetSelectionText',
					)}
				</H2>
				<AssetsWrapper>
					{possibleAssets.map((asset) => (
						<AssetCard
							key={asset.id}
							asset={asset}
							hasBorder
							isSelected={expenseEstimate.assetId == asset.id}
							onSelect={(isSelected) =>
								assignAsset(asset.id.toString(), isSelected)
							}
							variant="preview"
						/>
					))}
					<ItemWithOptionalLogo
						title={t(
							'assetExpenses-missingExpenseEstimateAssetLinkPage-removeChainOption-title',
						)}
						description={t(
							'assetExpenses-missingExpenseEstimateAssetLinkPage-removeChainOption-description',
						)}
						logo={<RemoveChain />}
						isRounded
						hasBorder
						isSelected={expenseEstimate.assetId == null}
						onItemSelect={(isSelected) => assignAsset(null, isSelected)}
					/>
				</AssetsWrapper>
			</div>
		</Wrapper>
	)
}
